import { Trans, useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { collectDetailsUTM } from '@/helpers/utm';
import { useReferrals } from '@/providers/referral';
import { useUserAuth } from '@/query/queries/auth/useUserAuth';
import { useReCaptcha } from '@/providers/recaptcha';
import { RefferalCode } from './referral';
import { EmailForm } from './form';
import s from './index.module.scss';

export const StepMain = ({ children, onEmailSubmit }) => {
  const { currentRefCode } = useReferrals();
  const { loaded, getCaptchaToken } = useReCaptcha();
  const { t } = useTranslation();
  const { mutateAsync: authenticate } = useUserAuth();

  const onSubmit = async ({ email }, formik) => {
    const token = await getCaptchaToken();

    if (!token) {
      return console.error('Captcha token failed.');
    }

    const payload = {
      email,
      referral_code: currentRefCode?.id || null,
      ...collectDetailsUTM(),
    };
    const res = await authenticate(payload);

    if (res?.temp_token) {
      return onEmailSubmit({ email, ...res });
    }

    formik.setSubmitting(false);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.inner}>
        <div className={s.header}>
          <h1 className={s.title}>{t('auth:step_main.title')}</h1>
          <p className={s.description}>{t('auth:step_main.description')}</p>
        </div>
        <EmailForm onSubmit={onSubmit} captchaLoaded={loaded}>
          <RefferalCode code={currentRefCode} />
        </EmailForm>
        <div className={s.divider}>
          <span>{t('auth:step_main.or')}</span>
        </div>
        {children}
      </div>
      <div className={s.footer}>
        <p>
          <Trans
            ns="auth"
            i18nKey="step_main.by_proceeding_with_registration"
            components={{
              Span: <span className="f-600" />,
              LinkTerms: (
                <MyLink
                  href={APP_LINKS.termOfUse}
                  className="f-600"
                  isExternal
                  underline
                />
              ),
              LinkPolicy: (
                <MyLink
                  href={APP_LINKS.privacyPolicy}
                  className="f-600"
                  isExternal
                  underline
                />
              ),
            }}
          />
        </p>
        <div className={s.compliance}>
          <Trans
            ns="footer"
            i18nKey="scramble_ou_not_crowdfunding"
            components={{ Bold: <span className="f-600" /> }}
          />
        </div>
      </div>
    </div>
  );
};
